import React, { Component } from "react";
import { Card } from "components/Card/Card.jsx";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";

export class PagIbigEntriesCard extends Component {
  handleFormChange = (event) => {
    const { name, value } = event.target;
    const { index, entry } = this.props;
    let updatedEntry = { ...entry };
    updatedEntry = {
      ...updatedEntry,
      [name]: value,
    };
    this.props.onUpdateEntry(updatedEntry, index);
  };

  render() {
    const { entry = {}, index, deleteEntry } = this.props;

    const {
      salaryFrom,
      salaryTo,
      employerShare,
      employeeShare,
      totalContribution,
    } = entry;

    return (
      <Card
        hideFooter
        key={`PagIbig-${index}`}
        title={`Entry`}
        content={
          <Row>
            <Col sm={12} md={2}>
              <FormGroup>
                <ControlLabel>Salary From</ControlLabel>
                <FormControl
                  type="number"
                  name="salaryFrom"
                  value={salaryFrom}
                  onChange={this.handleFormChange}
                  placeholder=""
                />
              </FormGroup>
            </Col>
            <Col sm={12} md={2}>
              <FormGroup>
                <ControlLabel>Salary To</ControlLabel>
                <FormControl
                  type="number"
                  name="salaryTo"
                  value={salaryTo}
                  onChange={this.handleFormChange}
                  placeholder=""
                />
              </FormGroup>
            </Col>
            <Col sm={12} md={2}>
              <FormGroup>
                <ControlLabel>Employer Share</ControlLabel>
                <FormControl
                  type="number"
                  name="employerShare"
                  value={employerShare}
                  onChange={this.handleFormChange}
                  placeholder=""
                />
              </FormGroup>
            </Col>
            <Col sm={12} md={2}>
              <FormGroup>
                <ControlLabel>Employee Share</ControlLabel>
                <FormControl
                  type="number"
                  name="employeeShare"
                  value={employeeShare}
                  onChange={this.handleFormChange}
                  placeholder=""
                />
              </FormGroup>
            </Col>
            <Col sm={12} md={3}>
              <div className="rule-actions">
                <FormGroup style={{ width: "100%" }}>
                  <ControlLabel>Total Contribution</ControlLabel>
                  <FormControl
                    type="number"
                    name="totalContribution"
                    value={totalContribution}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>
                {index !== 0 ? (
                  <i
                    className="pe-7s-trash"
                    onClick={() => deleteEntry(index)}
                  />
                ) : null}
              </div>
            </Col>
          </Row>
        }
      />
    );
  }
}

export default PagIbigEntriesCard;
